var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteBici(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.287 5.863c-.723 0-1.414.132-2.051.371-.499-1.08-.93-2.223-1.145-3.287C18.745 1.24 17.197 0 15.409 0c-.453 0-.82.358-.82.8 0 .441.367.8.82.8.195 0 .385.026.566.075.55.15 1.018.513 1.29 1-.022.027-.043.055-.062.086l-.254.418-1.29 2.116H8.771l-.392-.96h.163c.453 0 .82-.359.82-.8 0-.442-.367-.8-.82-.8H5.713c-.453 0-.82.358-.82.8 0 .441.367.8.82.8h.9L7.33 6.09c-.513-.147-1.056-.227-1.617-.227C2.563 5.863 0 8.36 0 11.43 0 14.501 2.563 17 5.713 17c2.872 0 5.255-2.076 5.654-4.769h1.507c.29 0 .557-.149.705-.391l4.31-7.074c.254.763.57 1.527.911 2.257-1.353 1.02-2.226 2.616-2.226 4.408 0 3.071 2.563 5.569 5.713 5.569S28 14.502 28 11.431c0-3.07-2.563-5.568-5.713-5.568zM5.713 12.23h3.99c-.381 1.807-2.025 3.17-3.99 3.17-2.245 0-4.072-1.78-4.072-3.97 0-2.188 1.827-3.969 4.072-3.969 1.965 0 3.609 1.363 3.99 3.17h-3.99c-.453 0-.82.358-.82.8 0 .441.367.799.82.799zm6.694-1.6h-1.04c-.19-1.284-.832-2.428-1.763-3.273-.009-.032-.018-.064-.031-.096l-.15-.368h5.262l-2.278 3.738zm9.88 4.77c-2.246 0-4.073-1.78-4.073-3.97 0-1.16.513-2.204 1.33-2.93 1.008 1.879 1.994 3.28 2.068 3.385.159.224.415.345.676.345.16 0 .323-.046.465-.142.373-.25.466-.748.209-1.112-.018-.025-1.01-1.436-2.004-3.297.417-.14.863-.218 1.329-.218 2.245 0 4.072 1.78 4.072 3.97 0 2.188-1.827 3.969-4.072 3.969z",
    transform: "translate(0 5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteBici);
export default __webpack_public_path__ + "static/media/transporte-bici.9c77fa9e.svg";
export { ForwardRef as ReactComponent };